export const getUserProfileImage = (avatar?: string) => {
  return avatar ?? "/images/logo-yellow-bg.png";
};
